module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADwAAAAMCAYAAAA+ht7fAAAAAXNSR0IArs4c6QAAADJJREFUSEvt0gEBAAAIwjBtbnMMYIN7GsDoJFOP0haGaysMBy6FFYYt4KVhoKeOwnThBSi4Kek+/Ps8AAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/rescuelist/ui_dot_active.png
// module id = H6Pu
// module chunks = 1